import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBuilding3 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M22 20a1 1 0 0 1 .117 1.993L22 22H2a1 1 0 0 1-.117-1.993L2 20h20Z" />
      <path d="M7 12H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2Zm-2 2h2v6H5v-6Z" />
      <path d="M6.5 16a1 1 0 0 1 .117 1.993L6.5 18H6a1 1 0 0 1-.117-1.993L6 16h.5Z" />
      <path d="M19 1H9a2 2 0 0 0-2 2v17a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM9 3h10v17H9V3Z" />
      <path d="M11 5h2v2h-2zM15 5h2v2h-2zM11 8.5h2v2h-2zM15 8.5h2v2h-2zM15 12h2v2h-2zM15 15.5h2v2h-2z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBuilding3)
const Memo = memo(ForwardRef)
export default Memo
